<template>
  <div class="finish-step-container">
    <a-card class="finish-card card">
      <div class="steps-body">
        <a-result
          status="success"
          :title="payment.after.title"
          class="payment-result"
        >
          <template #extra>
            <div v-html="paymentSuccess" class="payment-success-content" />
          </template>
        </a-result>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'FinishStep',
  props: {
    payment: {
      type: Object,
      required: true,
    },
    paymentSuccess: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.finish-step-container {
  margin-top: var(--spacing-md);
}

.finish-card {
  padding: var(--spacing-lg);
}

.steps-body {
  background: transparent;
  border-radius: 0;
}

.payment-result {
  padding: var(--spacing-lg) 0;
}

.payment-success-content {
  font-size: var(--font-size-base);
  line-height: var(--line-height-relaxed);
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .finish-card {
    padding: var(--spacing-md);
  }

  .payment-result {
    padding: var(--spacing-md) 0;
  }
}
</style>
